import {
  CheckCircleOutlined,
  RightOutlined,
  StopOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { PPE_PERSON_STATUS } from "utils/constants";
import { usePPEGEL } from "./PPEGELProvider";
import { computePersonStatus } from "./utils";

const statusIconMap = {
  [PPE_PERSON_STATUS.VERIFIED]: (
    <CheckCircleOutlined className="ppegel-person-selector__icon ppegel-person-selector__icon--verified" />
  ),
  [PPE_PERSON_STATUS.ALERT]: (
    <WarningOutlined className="ppegel-person-selector__icon ppegel-person-selector__icon--alert" />
  ),
  [PPE_PERSON_STATUS.BLOCKED]: (
    <StopOutlined className="ppegel-person-selector__icon ppegel-person-selector__icon--blocked" />
  ),
  [PPE_PERSON_STATUS.PENDING]: null,
};

const PersonSelector = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PPEGEL);
  const { persons, selectedPersonIndex, selectPerson, isBlocked } = usePPEGEL();

  return (
    <div className="ppegel-person-selector">
      <div className="ppegel-person-selector__header">
        <h3 className="ppegel-person-selector__title">{t("TITLE")}</h3>
        <p className="ppegel-person-selector__subtitle">{t("SUBTITLE")}</p>
      </div>
      <div className="ppegel-person-selector__list">
        {persons.map((person, index) => {
          const personStatus = isBlocked
            ? PPE_PERSON_STATUS.BLOCKED
            : computePersonStatus(person.alerts);
          const isSelected = index === selectedPersonIndex;

          return (
            <div
              key={person.personId || index}
              className={`ppegel-person-selector__item ${
                isSelected ? "ppegel-person-selector__item--active" : ""
              }`}
              onClick={() => selectPerson(index)}
            >
              <div className="ppegel-person-selector__left">
                {statusIconMap[personStatus]}
                <div className="ppegel-person-selector__info">
                  <span className="ppegel-person-selector__name">
                    {person.fullName}
                  </span>
                </div>
              </div>
              <RightOutlined className="ppegel-person-selector__chevron" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PersonSelector;
